const list = {
  height: '300px',
  overflowY: 'scroll',
  overflowX: 'hidden',
};

const window = {
  borderStyle: 'solid',
  borderWidth: '1px 0px 1px 1px',
  borderColor: '#e7e7e7',
  borderRadius: '5px',
};

export default { list, window };



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/components/UserSelect/style.js